<!--  -->
<template>
  <div>
    <div class="optionbox">
      <div class="optiontext">渠道名称：</div>
      <el-input v-model="name" style="width:300px" placeholder="请输入内容" />
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">推广成本：</div>
      <el-input v-model="money" style="width:300px" placeholder="(无推广请填写0)" type="number" @blur="activegivemoney" />
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">关注章节号：</div>
      <el-input v-model="follownum" style="width:300px" placeholder="(无关注章节号请填写0)" type="number" @blur="charnum" />
    </div>
    <el-button type="primary" @click="sumbit">确定</el-button>
  </div>
</template>

<script>
import { bookPlatformcreate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      name: '',
      money: 0,
      follownum: 0
    }
  },
  watch: {
    obj: {
      handler(newValue, oldValue) {
        // console.log('111', newValue)
        this.objquery = newValue
        this.name = newValue.bookname + '-' + newValue.chaptername
      },
      deep: true
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    activegivemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.money < 0 || this.money == '') {
        this.money = 0
      }
    },
    charnum() {
      // eslint-disable-next-line eqeqeq
      if (this.follownum < 0 || this.follownum == '') {
        this.follownum = 0
      }
      // 判断不能输入小数点
      const str = '' + this.follownum
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.follownum = 1
      }
    },
    async sumbit() {
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.name === '') {
        this.$message.error('请输入渠道名称')
        return
      }
      if (this.money === '') {
        this.$message.error('请输入推广成本')
        return
      }
      if (this.follownum === '') {
        this.$message.error('请输入关注章节号')
        return
      }
      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          cost: this.money,
          name: this.name,
          book_id: this.objquery.bookid,
          chapter_id: this.objquery.chapterid,
          push: this.objquery.radio,
          guide_chapter_id: this.follownum,
          chapter_name: this.objquery.chaptername
        }
      })
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext{
  width: 100px;
  text-align: right;
}
.loltext{
  margin-left: 100px;
}
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
